// 所有通用的枚举定义
export enum PlayerType {
  tenvideoH5 = 'tenvideoH5',
  tenvideoNative = 'tenvideoNative',
  wsPlayerH5 = 'wsPlayerH5',
  wsPlayerNative = 'wsPlayerNative'
}

export enum PlayState {
  PLAY = 'PLAY',
  PAUSE = 'PAUSE'
}

export enum BridgeType {
  tenvideoMp = 'tenvideoMp',
  tenvideoWeb = 'tenvideoWeb'
}
